<script setup lang="ts">
import type { InputTagProps } from "./input.types";
import { useInputTag } from "./useInputTag";

defineOptions({ name: "InputTag" });

const props = withDefaults(defineProps<InputTagProps>(), {
  color: "neutral",
  size: "md",
  disabled: false,
});

const { label, wrapperClass, removeButtonClass, handleRemove } = useInputTag({ props });
</script>

<template>
  <div :class="wrapperClass" :data-disabled="disabled || undefined">
    <e-group :size="size">
      <e-chip :color="color" :size="size">
        <slot>{{ label }}</slot>
      </e-chip>
      <e-button
        :class="removeButtonClass"
        :color="color"
        :size="size"
        square
        :disabled="disabled"
        tabindex="-1"
        aria-label="Remove tag"
        @click="handleRemove"
      >
        <e-icon name="close" size="xs" />
      </e-button>
    </e-group>
  </div>
</template>
